import React, { useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import FloatButton from '../sidebar/FloatButton';
import InappAddNewPopup from './InappAddNewPopup';
import { getInappDetails } from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';

export default function SidebarListInapp(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = React.useState(false);
  const selectedId = useSelector((state) => state.inappData.selectedId);
  const dispatch = useDispatch();

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});
  useEffect(() => {
    myRefs[selectedId]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [selectedId, filterArray]);

  const handleListItemClick = (id) => {
    dispatch(getInappDetails(id));
  };
  const addNewInapp = () => {
    setIsAddNewPopupOpen(true);
  };

  const closeAddNewInapp = () => {
    setIsAddNewPopupOpen(false);
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray.map((data) => (
          <div key={data.id} className={selectedId === data.id ? classes.highlightItem : ''}>
            <ListItem
              key={data.id}
              button
              selected={selectedId === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data.id)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`
                          ${selectedId === data.id ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                    >
                      {data.title}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={selectedId === data.id ? classes.listSubTextSelected : classes.listSubTextNonSelected}
                    >
                      <div className={classes.listSubTextJustify}>
                        <div>{`${data.dealerships?.length || 0} dealerships`}</div>
                        <div className={!data.enabled ? classes.secondaryTextRed : null}>
                          {' '}
                          {`${data.enabled ? 'Active' : 'Inactive'}`}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={0} mainTabID={9} onAddNewInapp={addNewInapp} />
      {isAddNewPopupOpen && <InappAddNewPopup close={closeAddNewInapp} add refreshData={props.fetchData} />}
      {<ShowProgress />}
    </div>
  );
}
